<template>
  <div v-cloak class="view-wrap">
    <div class="view-content">
      <onboard-wrap>
        <h1>Rawr! Invite accepted!</h1>
        <p>You can now download TunnelBear onto your devices and enjoy unlimited secure bear&#8209;owsing.</p>
        <a href="/download" class="btn btn-lg">Download Apps</a>
        <p>Or go to <router-link :to="{name: 'member-overview'}">my account</router-link></p>
      </onboard-wrap>
    </div>
  </div>
</template>

<script>
import teamWrap from '@/components/team-wrap/team-wrap'

export default {
  name: 'success',
  components: {
    'onboard-wrap': teamWrap
  },
  data () {
    return {}
  }
}
</script>

<style scoped lang="stylus" src="./success.styl" >



// WEBPACK FOOTER //
// src/views/success/success.vue